"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRootParams = void 0;
const calculator_types_1 = require("../components/fleet-calculator/calculator-types");
const voyage_types_1 = require("../components/voyage/voyage-types");
const isRootParams = (params) => {
    return (0, calculator_types_1.isCalculatorParams)(params) || (0, voyage_types_1.isVoyageParams)(params);
};
exports.isRootParams = isRootParams;
